module.exports = __webpack_public_path__ + "static/Goblin-d4d4bf8dd1e39d573ce800ee48bf4552.jpg";